// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import vueResource from 'vue-resource'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/global.css'
import 'iview/dist/styles/iview.css'; // 使用 CSS
import signout from './utils/signout.js'
import utilsnew from './utils/utils.js'
import img from './utils/img'
import iView from 'iview';
import dayjs from 'dayjs'
import "./style/index.css"
import "./style/index.scss"


Vue.prototype.$images = img
Vue.use(iView);
Vue.use(dayjs);
Vue.use(utilsnew)

import '@/config/permission'
import Vab from '@/utils/vab'
Vue.use(Vab)

// import { mapGetters } from 'vuex'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/display.css'

Vue.use(ElementUI, {
	size: 'small',
})

import VueAMap from 'vue-amap'
Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
	key: '3aefd45dd373ddbbd786b7b162aa6e0e',
	plugin: ['AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PlaceSearch',
		'AMap.Geolocation', 'AMap.Geocoder'
	],
	v: '1.4.4',
	uiVersion: '1.0'
})

// 引用axios
import api from './api/index'
// import echarts from 'echarts'
let echarts = require('echarts')

import html2canvas from 'html2canvas'
// Vue.prototype.$echarts = echarts
Vue.prototype.$api = api
Vue.prototype.$signout = signout
import nomore from '@/components/nomore.vue'
Vue.component("nomore", nomore); //

import header from '@/components/head/header.vue'
Vue.component("headerpage", header); //
import header1 from '@/components/head/header1.vue'
Vue.component("headerpage1", header1); //
import timechang from '@/components/timechang.vue'
Vue.component("timechangpage", timechang); //
import index from "./utils/index.js";
Vue.prototype.$index = index;

import chart from '@/components/chart.vue'
Vue.component("chartpage", chart); //

Vue.prototype.$echarts = function(el) {
	return echarts.init(el, null, {
		renderer: 'svg'
	})
}
Vue.config.productionTip = false
Vue.use(vueResource)
Vue.use(ElementUI)
/* eslint-disable no-new */
Vue.filter('addurl', function(url) { // msg 为固定的参数 即是你需要过滤的数据
	if (url) {
		if (url.indexOf('http') == -1) {
			var url = apiurl.api.baseurl1 + url;
		}
	}
	return url;
})

Vue.prototype.$time = function timestampToTime(timestamp) {
	var date = new Date(timestamp * 1000);
	var Y = date.getFullYear() + '-';
	var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
	var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
	var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
	var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
	var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
	return Y + M + D;
},

Vue.prototype.$days = function DateDiff(sDate1,  sDate2){ 
   //sDate1和sDate2是2006-12-18格式
   var  aDate1, aDate2,  oDate1,  oDate2,  iDays;
   aDate1  =  sDate1.split("-");
   oDate1  =  new  Date(aDate1[1]  +  '/'  +  aDate1[2]  +  '/'  +  aDate1[0]);
   aDate2  =  sDate2.split("-");
   oDate2  =  new  Date(aDate2[1]  +  '/'  +  aDate2[2]  +  '/'  +  aDate2[0]);
   iDays  =  parseInt(Math.abs(oDate1  -  oDate2) / 1000 / 60 / 60 / 24 );
  return  iDays
}

Vue.filter('time', function(value) {
	let date = new Date(value * 1000);
	if (date) {
		let y = date.getFullYear();
		let MM = date.getMonth() + 1;
		MM = MM < 10 ? ('0' + MM) : MM;
		let d = date.getDate();
		d = d < 10 ? ('0' + d) : d;
		let h = date.getHours();
		h = h < 10 ? ('0' + h) : h;
		let m = date.getMinutes();
		m = m < 10 ? ('0' + m) : m;
		let s = date.getSeconds();
		s = s < 10 ? ('0' + s) : s;
		return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;

	}
	return url
})
Vue.filter('time1', function(value) {
	let date = new Date(value * 1000);
	if (date) {
		let y = date.getFullYear();
		let MM = date.getMonth() + 1;
		MM = MM < 10 ? ('0' + MM) : MM;
		let d = date.getDate();
		d = d < 10 ? ('0' + d) : d;
		let h = date.getHours();
		h = h < 10 ? ('0' + h) : h;
		let m = date.getMinutes();
		m = m < 10 ? ('0' + m) : m;
		let s = date.getSeconds();
		s = s < 10 ? ('0' + s) : s;
		return y + '-' + MM + '-' + d;

	}
	return url
})
Vue.prototype.ExportSavePdf = ({
	id,
	name,
	time: currentTime
}) => {
	let element = document.getElementById(id)
	html2canvas(element, {
		logging: false,
		scale: 2,
		useCORS: true
	}), then((canvas) => {
		let pdf = new JSPDF("p", "mm", "a4") // A4纸，纵向
		let ctx = canvas.getContext("2d")
	})
}
// router.beforeEach((to, from, next) => {
//   //路由发生改变时,触发
//   window.document.title = to.meta.title == undefined ? '政策宝' : to.meta.title
//   // if (to.meta.requireAuth) {
//   //     let token = Cookies.get('access_token');
//   //     let anonymous = Cookies.get('user_name');
//   //     if (token) {
//   //          next({
//   //              path: '/login',
//   //              query: {
//   //                  redirect: to.fullPath
//   //              }
//   //          })
//   //     }
//   // }
//   next();
// })

var whiteList1 = []

// router.beforeEach((to, from, next) => { 
//   let token = localStorage.getItem('token')
//   // console.log(to.path)
//   // console.log(whiteList)
//   // if(whiteList.indexOf(to.path) != -1){
//   //   // console.log("白名单")
//   //   next()
//   //   return
//   // } 
//   console.log(token)
//   if(!token&&whiteList1.indexOf(to.path)!==-1){
//     // websocketRequest.closeWebSocket();
//     console.log(555)
//     next('/login');
//     return
//   }
//   //配置动态路由信息
//   let newRouter = null;

//   if(store.getters.newRouter === newRouter){
//     next()
//   }
//   // else{
//   //     router.addRoutes(newRouter) //添加动态路由
//   //     store.dispatch('routerAction',newRouter).then(res => {
//   //       next({ ...to })
//   //     }).catch(() => {
//   //     })
//   // } 

// })

// router.afterEach((to, from, next) =>{ 
//   if(to.matched.length==0){ 
//      router.push({
//       path: "/index"
//     });
//     return
//   } 
// })


new Vue({
	el: '#app',
	router,
	store,
	template: '<App/>',
	components: {
		App
	}
})


// WEBPACK FOOTER //
// ./src/main.js